export const APPLICATION_LANGUAGES = [
    { value: 'en', label: 'common.application-languages.english' },
];
export const UNITS_OF_MEASURE = [
    { value: 'metric', label: 'common.units-of-measure.metric' },
    { value: 'imperial', label: 'common.units-of-measure.imperial' },
];
